import React from 'react';

import { FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { AboutTheProject } from './AboutTheProject';
import { CompanyHistoryProject } from './CompanyHistoryProject';
import { GeneralInfoProject } from './GeneralInfoProject';
import { ImplementationPlan } from './ImplementaionPlan';
import { SWOTAnalysis } from './SWOTAnalysis';
import { IForInvestorFormSubSections } from '../forInvestorsSections';

const SUB_SECTIONS: IForInvestorFormSubSections = {
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_COMPANY_AND_PROJECT.GENERAL_INFO]: GeneralInfoProject,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_COMPANY_AND_PROJECT.COMPANY_HISTORY]: CompanyHistoryProject,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_COMPANY_AND_PROJECT.ABOUT_THE_PROJECT]: AboutTheProject,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_COMPANY_AND_PROJECT.IMPLEMENTATION_PLAN]: ImplementationPlan,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_COMPANY_AND_PROJECT.SWOT]: SWOTAnalysis,
};

export const CompanyAndProject: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
